import React ,{useState} from 'react'
import FullImageModal from './FullImageModal';

function SchemeImage() {

    const products = [
        {
            id: 1,
            name: 'Earthen Bottle',
            href: '#',
            price: '$48',
            imageSrc: '/urboncoBank/schemeImage/scheme1.jpeg',
            imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
        },
        {
            id: 2,
            name: 'Nomad Tumbler',
            href: '#',
            price: '$35',
            imageSrc: '/urboncoBank/schemeImage/scheme2.jpeg',
            imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
        },
        {
            id: 3,
            name: 'Focus Paper Refill',
            href: '#',
            price: '$89',
            imageSrc: '/urboncoBank/schemeImage/scheme3.jpeg',
            imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
        },
        {
            id: 4,
            name: 'Machined Mechanical Pencil',
            href: '#',
            price: '$35',
            imageSrc: '/urboncoBank/schemeImage/scheme4.jpeg',
            imageAlt: 'Hand holding black machined steel mechanical pencil with brass tip and top.',
        },
        {
            id: 5,
            name: 'Earthen Bottle',
            href: '#',
            price: '$48',
            imageSrc: '/urboncoBank/schemeImage/scheme5.jpeg',
            imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
        },
        {
            id: 6,
            name: 'Nomad Tumbler',
            href: '#',
            price: '$35',
            imageSrc: '/urboncoBank/schemeImage/scheme6.jpeg',
            imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
        },
        {
            id: 7,
            name: 'Focus Paper Refill',
            href: '#',
            price: '$89',
            imageSrc: '/urboncoBank/schemeImage/scheme7.jpeg',
            imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
        },
        {
            id: 8,
            name: 'Machined Mechanical Pencil',
            href: '#',
            price: '$35',
            imageSrc: '/urboncoBank/schemeImage/scheme8.jpeg',
            imageAlt: 'Hand holding black machined steel mechanical pencil with brass tip and top.',
        },
    ]


    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (imageUrl) => {
        setSelectedImage(imageUrl);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    return (
        <div>

            {selectedImage && (
                <FullImageModal
                    imageUrl={selectedImage}
                    alt="Full Image"
                    onClose={closeModal}
                />
            )}

            <div className="bg-white">
                <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
                    <h2 className="sr-only">Products</h2>

                    <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
                        {products.map((product) => (
                            <a key={product.id}  onClick={() => openModal(product.imageSrc)} className="group">
                                <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7 ">
                                    <img
                                        src={product.imageSrc}
                                        alt={product.imageAlt}
                                        className="h-full w-full object-cover object-center group-hover:opacity-75"
                                    />
                                </div>
                               
                            </a>
                        ))}
                    </div>
                </div>
            </div>


        </div>
    )
}

export default SchemeImage
